export class UserDataService {
    public static updateUserLinkRoles(id, roles, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/user/link/${id}/updateroles`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(roles),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static removeUserLink(id, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/user/link/${id}/remove`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}